// Placeholders a reply snippet ("vastauspohja") may contain. The composer fills
// the ones it knows from context; anything unresolved stays visible as
// "{päivä}" so the rep sees what is left to fill in by hand.
export const REPLY_SNIPPET_VARIABLES = [
  { key: 'etunimi', label: 'Vastaanottajan etunimi' },
  { key: 'sukunimi', label: 'Vastaanottajan sukunimi' },
  { key: 'osoite', label: 'Kohteen katuosoite' },
  { key: 'kaupunki', label: 'Kohteen kaupunki' },
  { key: 'palvelu', label: 'Palvelu' },
  { key: 'minä', label: 'Oma etunimi' },
  { key: 'laskunumero', label: 'Laskun numero' },
  { key: 'loppusumma', label: 'Laskun loppusumma' },
  { key: 'suoritukset', label: 'Laskulle kirjatut suoritukset' },
  { key: 'palautus', label: 'Palautettava summa' },
] as const

// Typed after "/" in the composer, so keep it to what fits on a keyboard
export const REPLY_SNIPPET_SHORTCUT_PATTERN = /^[a-z0-9äöå-]+$/

export type ReplySnippetVariable =
  (typeof REPLY_SNIPPET_VARIABLES)[number]['key']

export type ReplySnippetVars = Partial<
  Record<ReplySnippetVariable, string | null | undefined>
>

export function renderReplySnippet(
  body: string,
  vars: ReplySnippetVars,
): string {
  return body.replace(/\{([^{}\s]+)\}/g, (match, key: string) => {
    const value = vars[key as ReplySnippetVariable]
    return value?.trim() ? value.trim() : match
  })
}

const PLACEHOLDER = /\{[^{}\s]+\}/g

// Placeholders still left in a message, e.g. ["{päivä}", "{klo}"]. Used to
// block sending until the rep has filled them in.
export function findUnresolvedPlaceholders(text: string): string[] {
  return [...new Set(text.match(PLACEHOLDER) ?? [])]
}

// Where the first placeholder sits, so the composer can select it right after
// inserting a snippet and typing replaces it directly.
export function firstPlaceholderRange(
  text: string,
): { start: number; end: number } | null {
  const match = new RegExp(PLACEHOLDER.source).exec(text)
  return match
    ? { start: match.index, end: match.index + match[0].length }
    : null
}
